/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import EasySwipe from 'react-easy-swipe';
import { Modal, List } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import { CloseIcon } from '@shared/assets/icons';
import loginSteam from '@shared/assets/images/cyber/loginSteam.jpg';
import loginSteamMobile from '@shared/assets/images/cyber/loginSteamMobile.jpg';
interface ModalBannerProps {
  open: boolean;
  handleClose: () => void;
}
export const SteamTooltipMobile: FC<ModalBannerProps> = ({
  open,
  handleClose
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [swipeDirection, setSwipeDirection] = useState('');
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    setIsClosing(!open);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      handleClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={handleCloseModal} closeIcon={<CloseIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Heading>Как найти свой логин в&nbsp;Steam?</Heading>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <WrapperList>
            <List data={[{
            id: 1,
            text: 'Откройте клиент Steam. Нажмите на имя пользователя в правом верхнем углу главной страницы.'
          }, {
            id: 2,
            text: 'В выпадающем меню выберите пункт «Об аккаунте».'
          }]} size="md" sizemob="md" />
          </WrapperList>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <ImageWrapper>
            <Image src={loginSteam} width={536} height={140} alt="login steam" style={{
            borderRadius: '16px'
          }} />
          </ImageWrapper>
          <ImageWrapperMobile>
            <Image src={loginSteamMobile} width={335} height={140} alt="login steam" style={{
            borderRadius: '16px'
          }} />
          </ImageWrapperMobile>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "s1my5gca",
  propsAsIs: true,
  vars: {
    "s1my5gca-0": [_exp1()],
    "s1my5gca-1": [_exp3()],
    "s1my5gca-2": [_exp7(), "px"],
    "s1my5gca-3": [_exp5()],
    "s1my5gca-4": [_exp6(), "px"],
    "s1my5gca-5": [_exp8()],
    "s1my5gca-6": [_exp9()],
    "s1my5gca-7": [_exp0()]
  }
}));
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperList = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperList",
  class: "whxot41",
  propsAsIs: false,
  vars: {
    "whxot41-0": [_exp10()]
  }
}));
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp15 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h1a35nsb",
  propsAsIs: false,
  vars: {
    "h1a35nsb-0": [_exp11()],
    "h1a35nsb-1": [_exp12(), "px"],
    "h1a35nsb-2": [_exp13()],
    "h1a35nsb-3": [_exp14(), "px"],
    "h1a35nsb-4": [_exp15()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i1hicah2",
  propsAsIs: false
});
const ImageWrapperMobile = /*#__PURE__*/styled('div')({
  name: "ImageWrapperMobile",
  class: "icnjyc4",
  propsAsIs: false
});

require("./SteamTooltipMobile.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamTooltipMobile.tsx");